const PORTAL_ID = "145318383";
const FORM_ID = "0eae09af-69ce-405e-9660-5f92ad1a3328";
const ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`;

export async function submitToHubspot({ firstName, lastName, email, phone, typeOfBusiness, locations, message, pageUri, pageName }) {
  const fields = [
    { name: "firstname", value: firstName },
    { name: "lastname", value: lastName },
    { name: "email", value: email },
    { name: "phone", value: phone },
    { name: "type_of_business", value: typeOfBusiness },
    { name: "message", value: message },
  ];

  if (locations && locations.length > 0) {
    fields.push({ name: "location", value: locations.join(";") });
  }

  const payload = {
    fields,
    context: {
      pageUri: pageUri || window.location.href,
      pageName: pageName || document.title,
    },
  };

  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || "Form submission failed");
  }

  return true;
}